import { render, staticRenderFns } from "./AnnotationLayer.vue?vue&type=template&id=3bb513ac&scoped=true&"
import script from "./AnnotationLayer.vue?vue&type=script&lang=js&"
export * from "./AnnotationLayer.vue?vue&type=script&lang=js&"
import style0 from "./AnnotationLayer.vue?vue&type=style&index=0&id=3bb513ac&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bb513ac",
  null
  
)

export default component.exports